import React from 'react'
import PropTypes from 'prop-types'
import ProductSpecialOffers from '../../../components/special-offer/product-special-offers'
import useProductSpecialOffers from '../../../hooks/use-product-special-offers'

const CartBonusOffer = ({product, bonusPromotion, variant, ...rest}) => {
    const productSpecialOffersProps = useProductSpecialOffers(product, bonusPromotion, variant)

    return <ProductSpecialOffers {...productSpecialOffersProps} {...rest} />
}

CartBonusOffer.propTypes = {
    product: PropTypes.object,
    bonusPromotion: PropTypes.object,
    variant: PropTypes.string
}

export default CartBonusOffer
